import React from 'react'
import './spinner.css'

class Spinner extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
      if (!this.props.visible) {
        return (<div></div>);
      } else {
        return (
          <div className="loading-spinner" className={(this.props.solid ? 'solid' : '')} ></div>
        )
      }
    }
}

export default Spinner


// WEBPACK FOOTER //
// ./src/components/shared/spinner.js